import { render, staticRenderFns } from "./RsaGestionePresenzeProgrammatiComponent.vue?vue&type=template&id=6f596fd2"
import script from "./RsaGestionePresenzeProgrammatiComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestionePresenzeProgrammatiComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestionePresenzeProgrammatiComponent.vue?vue&type=style&index=0&id=6f596fd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports